// extracted by mini-css-extract-plugin
export default {"multy--how":"MultyHow_multy--how__L8je7"};